module.exports = __webpack_public_path__ + "img/icon-letter-v.778a5c50.svg";